import {useChatbot} from "./ChatboxProvider";
import React, {useEffect} from "react";

export const InitChat = () => {
    const { handleInit, isLoaded } = useChatbot()
    useEffect(() => {
        if (!isLoaded) {
            handleInit()
        }
    }, [isLoaded, handleInit]);
    return <></>
}

class Chatbot {

    static instance;
    accessToken;
    chat = null;
    constructor(accessToken, confirmation) {
        if (Chatbot.instance) return Chatbot.instance;
        this.accessToken = accessToken;
        this.init()
        this.styleInit()
        Chatbot.instance = this;
    }

    init() {
        /* eslint-disable */
        const urlChatServiceNow = process.env.REACT_APP_ENVIRONMENT
            ? process.env.REACT_APP_ENVIRONMENT === 'prod'
                ? 'https://vertem.service-now.com/'
                : 'https://grupoltmdev.service-now.com'
            : 'https://vertem.service-now.com/'

        // tokenParticipant: Token do Participant
        const ServiceChat = (typeof ServiceNowChat != 'undefined') ? ServiceNowChat: null
        if (!this.chat && ServiceChat) {
            this.chat = new ServiceChat({
                instance: urlChatServiceNow,
                context: {
                    projectId: process.env.REACT_APP_TENANT_ID,
                    token: this.accessToken
                },
                branding: {
                    bgColor: '#333',
                    primaryColor: '#000',
                    hoverColor: '#605e5e',
                    activeColor: '#AAA',
                    sizeMultiplier: 1
                }
            })
        }
    }

    styleInit() {
        new Promise(resolve => {
            const getElement = () => {
                let element =
                    !!document
                        .querySelector('now-requestor-chat-popover')
                        .shadowRoot.querySelector(
                            '.now-requestor-chat-popover-position.right'
                        ) &&
                    !!document
                        .querySelector('now-requestor-chat-popover')
                        .shadowRoot.querySelector(
                            '.now-requestor-chat-popover-position.right'
                        )
                        .querySelector('.now-requestor-chat-popover-dialog')
                        .shadowRoot.querySelector('.now-modeless-dialog')
                if (element) {
                    resolve(this.botStyle())
                } else {
                    window.requestAnimationFrame(getElement)
                }
            }
            getElement()
        })
    }

    botStyle() {
        const getShadowRoot = (elem, selector) =>
            elem.shadowRoot.querySelector(selector)

        const chatBoxElement = document.querySelector('now-requestor-chat-popover')

        const chatBoxContainer = getShadowRoot(
            chatBoxElement,
            '.now-requestor-chat-popover-position.right'
        )

        const chatDialogBox = chatBoxContainer.querySelector(
            '.now-requestor-chat-popover-dialog'
        )

        const dialogShadowOpen = getShadowRoot(chatDialogBox, '.now-modeless-dialog')

        chatBoxContainer.setAttribute(
            'style',
            'margin: 20px; width: calc(100% - 40px); height: calc(100% - 40px); pointer-events: none;'
        )

        chatDialogBox.setAttribute(
            'style',
            'height: 100%; max-height: 500px; min-height: 400px;'
        )

        dialogShadowOpen.setAttribute('style', 'width: 100%; height: 100%;')

        // MEDIA QUERY MAX-WIDTH 500px
        if (window.innerWidth <= 500) {
            dialogShadowOpen.setAttribute( 'style',
                'max-height: calc(100vh - 100px);width: 100%; height: 100%;'
            )

            chatBoxContainer.setAttribute(
                'style',
                'margin: 15px; width: calc(100% - 30px); height: calc(100% - 30px); pointer-events: none;'
            )

            chatBoxContainer
                .querySelector('.now-requestor-chat-popover-dialog')
                .setAttribute(
                    'style',
                    'width: 100%; height: 100%; max-height: 500px; min-height: 400px;'
                )
        }
        return true;
    }
}

export default Chatbot;

